import { HistorySortBy } from "PFTypes";
import { useCallback, useMemo, useState } from "react";

import {
  ActivityHistoryContext,
  ActivityHistoryFilters,
  EMPTY_ACTIVITY_HISTORY_FILTERS
} from "./activity_history_context";

type ActivityHistoryContextProviderProps = {
  children: React.ReactNode;
};

export const ActivityHistoryContextProvider = ({ children }: ActivityHistoryContextProviderProps) => {
  const [sortBy, setSortBy] = useState<HistorySortBy>(HistorySortBy.Latest);
  const [page, setPage] = useState(1);
  const [filters, setFiltersState] = useState<ActivityHistoryFilters>(EMPTY_ACTIVITY_HISTORY_FILTERS);

  const setFilters: React.Dispatch<React.SetStateAction<ActivityHistoryFilters>> = useCallback((value) => {
    setFiltersState(value);
    setPage(1);
  }, []);

  const contextValue = useMemo(
    () => ({ sortBy, setSortBy, page, setPage, filters, setFilters }),
    [page, sortBy, filters, setFilters]
  );

  return <ActivityHistoryContext.Provider value={contextValue}>{children}</ActivityHistoryContext.Provider>;
};
